import { TriangleAlert } from 'lucide-react';

import { defineArea } from '../../app/area';
import { ExceptionsPage } from './ExceptionsPage';

/**
 * OWNER: web shell for the route + placeholder; the CONTENT (the
 * `sync_rejections` inbox, ARCHITECTURE §6) is filled in by whichever agent
 * builds `apps/api/src/sync` follow-ups — most likely M2/M5, since a rejection
 * is always a stock or pick command that failed to apply.
 *
 * Kept as its own area precisely because it is cross-module: no single domain
 * module owns "everything the scanners could not apply".
 */
export default defineArea({
  id: 'exceptions',
  nav: [
    {
      section: 'system',
      to: '/exceptions',
      labelKey: 'common:nav.exceptions',
      icon: TriangleAlert,
      permissions: ['warehouse.stock.movements', 'picking.rounds.manage'],
      order: 10,
    },
  ],
  routes: [{ path: 'exceptions', element: <ExceptionsPage /> }],
});
